import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../layouts/Layout';
import GetJurnal from '../../componen/jurnal/GetJurnal';

export const GetJurnalPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
       <GetJurnal />
     </Layout>
  )
}
